// extracted by mini-css-extract-plugin
export default {"root":"ooZiQQkuc1RxWSl_XDtz","placeHolderShimmer":"mqxEaRws4UFkpNvs84Dq"};